<template>
  <div>
    <!-- Os steps foram feitos dessa maneira e não de uma maneira mais dinamica pois houveram alguns problemas para fazer isso. v-slot não aceita dados dinamicos e é necessario que os steps sejam renderizados dinamicamente. as refs de cada form também não estavam ficando certas com a dinamissidade -->

    <!-- Fluxo de evento com todos os steps para quando o usuario for ADMIN -->
    <MultiStepper
      :freeNavigate="isEditing && isAdmin"
      v-if="getEventType === 'EVENTO'"
      :data="data"
    >
      <template v-slot:content1>
        <BasicInformation ref="basicInformationForm" />
      </template>
      <template v-slot:content2>
        <SectorMap ref="sectorMapForm" />
      </template>
      <template v-slot:content3> <TicketManagement /> </template>
      <template v-slot:content4> <EventImages /> </template>
      <template v-slot:content5>
        <GeneralSettings ref="generalSettingsForm" />
      </template>
    </MultiStepper>

    <!-- Fluxo de evento sem step de ingresso e mapa de setores para quando o usuario, independente de qual for, estiver criando um evento LINK -->
    <MultiStepper
      v-else-if="getEventType === 'LINK'"
      :freeNavigate="isEditing && isAdmin"
      :data="
        data.filter(
          step => step.name !== 'sectorMap' && step.name !== 'ticketManagement'
        )
      "
    >
      <template v-slot:content1>
        <BasicInformation ref="basicInformationForm" />
      </template>
      <template v-slot:content2> <EventImages /> </template>
      <template v-slot:content3>
        <GeneralSettings ref="generalSettingsForm" />
      </template>
    </MultiStepper>
  </div>
</template>

<script>
import MultiStepper from "../../../components/MultiStepper.vue";
import BasicInformation from "../../../components/events/BasicInformation.vue";
import SectorMap from "../../../components/events/SectorMap.vue";
import TicketManagement from "../../../components/events/TicketManagement.vue";
import EventImages from "../../../components/events/EventImages.vue";
import GeneralSettings from "../../../components/events/GeneralSettings.vue";

import { mapGetters, mapActions, mapMutations } from "vuex";
import { processEventName } from "@/utils";
import { convertObjectToArray, extractAndRemoveLocale } from "../../../utils";
import { getTicketDates } from "../../../api";
import store from "../../../store";

export default {
  name: "EventSettings",
  components: {
    MultiStepper,
    BasicInformation,
    SectorMap,
    TicketManagement,
    EventImages,
    GeneralSettings,
  },
  data() {
    return {
      getTicketDates,
      data: [
        {
          title: this.$t("new-event.basic-information.title"),
          name: "basicInformation",
          disabledPrev: true,
          showPrev: true,
          next: () => {
            return this.basicInformation();
          },
        },
        {
          title: this.$t("new-event.sector-map.title"),
          name: "sectorMap",
          showPrev: true,
          next: () => {
            return this.sectorMap();
          },
        },
        {
          title: this.$t("new-event.ticket-management.title"),
          name: "ticketManagement",
          showPrev: true,
          exist: true,
          next: () => {
            return this.ticketManagement();
          },
        },
        {
          title: this.$t("new-event.images.title"),
          name: "eventImages",
          showPrev: true,
          next: () => {
            return this.eventImages();
          },
        },
        {
          title: this.$t("new-event.settings.title"),
          name: "generalSettings",
          showPrev: true,
          next: () => {
            return this.generalSettings();
          },
          textNext: this.$t("new-event.settings.next-button"),
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getEventBasicData",
      "getEventSectorData",
      "getEventSettingsData",
      "storeSequencial",
      "storeInfo",
      "addresses",
      "getCurrentEvent",
      "getEventImages",
      "getIdEvent",
      "isAdmin",
      "getEventType",
      "isAdmin",
    ]),

    locale() {
      return this.$i18n.locale;
    },
    isEditing() {
      return this.$route.path.includes("editar-evento");
    },
    isDoubleEvent() {
      return this.$route.path.includes("duplicar-evento");
    },
    basicInformationFormValidation() {
      return this.isValidForm("basicInformationForm");
    },
    generalSettingsFormValidation() {
      return this.isValidForm("generalSettingsForm");
    },
    sectorMapForm() {
      const isValid =
        (this.getEventSectorData.hasSector &&
          this.getEventSectorData.sectors.length != 0) ||
        !this.getEventSectorData.hasSector;
      return isValid;
    },
  },
  methods: {
    ...mapActions([
      "showSnackbarError",
      "createEvent",
      "updateEvent",
      "createSector",
      "updateSector",
      "cleanAll",
      "populateLocation",
    ]),
    ...mapMutations([
      "setEventBasicData",
      "setEventSectorData",
      "setEventImages",
      "setSelectedLocales",
      "setEventSettingsData",
      "setEventSettingsDataCached",
      "setTypeImageSelected",
      "setEventType",
      "setSelectedDateToTickets",
      "setDatesOfTickets",

      "addTicketToList",
      "addProductToList",
      "addRechargeToList",
    ]),
    isValidForm(formToValidate) {
      if (this.$refs[formToValidate] && this.$refs[formToValidate].$refs.form) {
        return this.$refs[formToValidate].$refs.form.validate();
      }
      return false;
    },
    async basicInformation() {
      const isValid = this.$refs.basicInformationForm.$refs.form.validate();
      if (!isValid) return false;

      try {
        const isCreateRoute = this.$route.path === "/gerenciar/cadastrar";
        if (!this.getEventSettingsData?.url && isCreateRoute) {
          await this.createEvent();
        } else {
          await this.updateEvent();
        }

        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },

    async sectorMap() {
      const { hasSector, sectors } = this.getEventSectorData;

      if (hasSector && sectors.length === 0) {
        this.showSnackbarError(this.$t("new-event.sector-map.error-quantity"));
        return false;
      }

      return true;
    },
    async ticketManagement() {
      try {
        await this.updateEvent();
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async eventImages() {
      const hasDestaque = this.getEventImages.some(
        image => image.type === "destaque"
      );
      const hasImagem1 = this.getEventImages.some(
        image => image.type === "imagem1"
      );
      if (this.getEventImages.length < 2) {
        this.showSnackbarError(this.$t("new-event.images.min-image"));
        return false;
      }
      if (!hasDestaque || !hasImagem1) {
        this.showSnackbarError(this.$t("new-event.images.min-image-type"));
        return false;
      }
      try {
        await this.updateEvent();
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async generalSettings() {
      const isValid = this.$refs.generalSettingsForm.$refs.form.validate();
      if (!isValid) return;

      try {
        await this.updateEvent();
        this.$router.push({ name: "events" });
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    mountStepTickets() {
      this.setDatesOfTickets([]);
      const { variantes } = this.getCurrentEvent;
      const sortedVariations = variantes?.variacoes_produto?.sort(
        (a, b) => a.ordenacao - b.ordenacao
      );
      const uniqueDates = new Set();

      const hasBatchs = sortedVariations?.some(
        variation => variation.ordem_lote > 1
      );

      sortedVariations?.map(variation => {
        const translatedDescriptions = processEventName(variation.descricao);
        if (variation.tipo === "INGRESSO") {
          let disabled = [];
          if (hasBatchs && variation.ordem_lote > 0) {
            disabled.push("batch");
            disabled.push("sector");
          }
          if (variation.cortesia === 1 || variation.gratuidade === 1) {
            disabled.push("price");
          }

          if (variation.meio_ingresso) {
            disabled.push("price");
          }

          uniqueDates.add(variation.dthr_ingresso);

          this.addTicketToList({
            idproduto_variacao: variation.idproduto_variacao,
            nidvariacao: variation.nidvariacao,
            id: variation.idproduto_variacao,
            name: translatedDescriptions[this.$i18n.locale],
            nameLocales: translatedDescriptions,
            sector: variation.idsetor,
            disabled: disabled.length > 0 ? disabled : "",
            batch: variation.ordem_lote,
            order: variation.ordenacao,
            price: variation.preco,
            half: variation.meio_ingresso,
            quantity: variation.quantidade,
            ticketDate: variation.dthr_ingresso,
            salesChannel: variation.canal_venda,
            description: variation.descritivo,
            accessPeriodStart: variation.dthr_inicio_checkin,
            accessPeriodEnd: variation.dthr_termino_checkin,
            salesPeriodStart: variation.dthr_inicio_vendas,
            salesPeriodEnd: variation.dthr_termino_vendas,
            accessQuantity: variation.limite_uso,
            dateChangeBatch: variation.dthr_virada_lote,
            isCourtesy: variation.cortesia === 1,
            isGratuity: variation.gratuidade === 1,
            isReservation: variation.reserva === 1,
            integrationComplement: variation.complemento_integracao,
            blockQuantity: variation.quantidade_bloqueada,
            comboOnly: variation.combo_only,
            ticketFacial: variation.facial,
            ticketFacialRequired: variation.facial_obrigatoria,
            commissionWeb: variation.tipo_taxa_web,
            typeTaxWeb:
              variation.taxa_conveniencia_porcentagem_custom_web > 0 ||
              variation.comissao_porcentagem_custom_web > 0
                ? "percent"
                : "value",
            taxWeb:
              [
                variation.comissao_web,
                variation.taxa_conveniencia_web,
                variation.taxa_conveniencia_porcentagem_custom_web,
                variation.comissao_porcentagem_custom_web,
              ].find(value => value > 0) || 0,
            minimumTax: variation.taxa_minima,
            commissionPos: variation.tipo_taxa_pos,
            typeTaxPos:
              variation.taxa_conveniencia_porcentagem_custom_pos > 0 ||
              variation.comissao_porcentagem_custom_pos > 0
                ? "percent"
                : "value",
            taxPos:
              [
                variation.comissao_pos,
                variation.taxa_conveniencia_pos,
                variation.taxa_conveniencia_porcentagem_custom_pos,
                variation.comissao_porcentagem_custom_pos,
              ].find(value => value > 0) || 0,
            hasProcessingTax: variation.taxa_processamento > 0,
            processingTax: variation.taxa_processamento,
            type: "INGRESSO",
            status: variation.status,
            previousBatch: variation.idprod_var_lote,
          });
        }
        if (variation.tipo === "RECARGA") {
          this.addRechargeToList({
            idproduto_variacao: variation.idproduto_variacao,
            nidvariacao: variation.nidvariacao,
            id: variation.idproduto_variacao,
            price: variation.preco,
            order: variation.ordenacao,
            quantity: variation.quantidade,
            salesPeriodStart: variation.dthr_inicio_vendas,
            salesPeriodEnd: variation.dthr_termino_vendas,
            salesChannel: variation.canal_venda,
            description: variation.descritivo,
            commissionWeb: variation.tipo_taxa_web,
            typeTaxWeb:
              variation.taxa_conveniencia_porcentagem_custom_web > 0 ||
              variation.comissao_porcentagem_custom_web > 0
                ? "percent"
                : "value",
            taxWeb:
              [
                variation.comissao_web,
                variation.taxa_conveniencia_web,
                variation.taxa_conveniencia_porcentagem_custom_web,
                variation.comissao_porcentagem_custom_web,
              ].find(value => value > 0) || 0,
            minimumTax: variation.taxa_minima,

            commissionPos: variation.tipo_taxa_pos,
            typeTaxPos:
              variation.taxa_conveniencia_porcentagem_custom_pos > 0 ||
              variation.comissao_porcentagem_custom_pos > 0
                ? "percent"
                : "value",
            taxPos:
              [
                variation.comissao_pos,
                variation.taxa_conveniencia_pos,
                variation.taxa_conveniencia_porcentagem_custom_pos,
                variation.comissao_porcentagem_custom_pos,
              ].find(value => value > 0) || 0,
            hasProcessingTax: variation.taxa_processamento > 0,
            processingTax: variation.taxa_processamento,
            elevenCash: variation.codigo_eleven_cash,
            status: variation.status,
            type: "RECARGA",
          });
        }
        if (variation.tipo === "PRODUTO") {
          this.addProductToList({
            disabled: "quantity",
            idproduto_variacao: variation.idproduto_variacao,
            nidvariacao: variation.nidvariacao,
            name: translatedDescriptions[this.$i18n.locale],
            nameLocales: translatedDescriptions,
            order: variation.ordenacao,
            id: variation.idproduto_variacao,
            images: variation.imagem.length ? variation.imagem : [],
            price: variation.preco,
            quantity: variation.quantidade,
            comboOnly: variation.combo_only,
            salesChannel: variation.canal_venda,
            description: variation.descritivo,
            accessPeriodStart: variation.dthr_inicio_checkin,
            accessPeriodEnd: variation.dthr_termino_checkin,
            accessQuantity: variation.limite_uso,
            commissionWeb: variation.tipo_taxa_web,
            typeTaxWeb:
              variation.taxa_conveniencia_porcentagem_custom_web > 0 ||
              variation.comissao_porcentagem_custom_web > 0
                ? "percent"
                : "value",
            taxWeb:
              [
                variation.comissao_web,
                variation.taxa_conveniencia_web,
                variation.taxa_conveniencia_porcentagem_custom_web,
                variation.comissao_porcentagem_custom_web,
              ].find(value => value > 0) || 0,
            minimumTax: variation.taxa_minima,
            commissionPos: variation.tipo_taxa_pos,
            typeTaxPos:
              variation.taxa_conveniencia_porcentagem_custom_pos > 0 ||
              variation.comissao_porcentagem_custom_pos > 0
                ? "percent"
                : "value",
            taxPos:
              [
                variation.comissao_pos,
                variation.taxa_conveniencia_pos,
                variation.taxa_conveniencia_porcentagem_custom_pos,
                variation.comissao_porcentagem_custom_pos,
              ].find(value => value > 0) || 0,
            hasProcessingTax: variation.taxa_processamento > 0,
            processingTax: variation.taxa_processamento,
            type: "PRODUTO",
            status: variation.status,
            variation:
              variation.variacoes?.length > 0
                ? variation.variacoes?.map(item => {
                    return {
                      idvariacao_produto: item.idvariacao_produto,
                      size: item.tamanho,
                      color: item.cor,
                      colorName: item.nome_cor,
                      quantity: item.quantidade,
                      status: item.status,
                    };
                  })
                : [],
          });
        }
      });

      this.setDatesOfTickets(Array.from(uniqueDates));
      if (Array.from(uniqueDates).length < 2) {
        this.setSelectedDateToTickets(Array.from(uniqueDates)[0]);
      }
    },
  },
  mounted() {
    store.commit("setLoadingEvent", false);
  },
  beforeMount() {
    if (this.isEditing && this.getCurrentEvent) {
      this.setSelectedLocales(extractAndRemoveLocale(this.getCurrentEvent));
      this.setEventType(this.getCurrentEvent.tipo);

      const frequencyEvent = this.getCurrentEvent.dthr_apresentacao
        ? "UNICO"
        : "RECORRENTE";
      this.setEventBasicData({
        name: this.getCurrentEvent.descricao,
        description: this.getCurrentEvent.descritivo,
        expandDescription: this.getCurrentEvent.ver_mais === 1,
        category: this.getCurrentEvent.idcategoria,
        urlLink: this.getCurrentEvent.url_link,
        frequency: frequencyEvent,
        eventDate: this.getCurrentEvent.dthr_apresentacao,
        saleStart: this.getCurrentEvent.dthr_inicio,
        saleEnd: this.getCurrentEvent.dthr_termino,
        salesEndHoursAfter: this.getCurrentEvent.hora_termino_vendas,
        location: this.getCurrentEvent.end_local,
        showMap: this.getCurrentEvent.show_map === 1 ? true : false,
        country: this.getCurrentEvent.end_pais,
        state: this.getCurrentEvent.end_estado,
        city: this.getCurrentEvent.end_cidade,
        latitude: this.getCurrentEvent.latitude,
        longitude: this.getCurrentEvent.longitude,
      });
      this.populateLocation();

      this.mountStepTickets();
      this.setEventImages(convertObjectToArray(this.getCurrentEvent.imagens));
      const digitalWallet = this.getCurrentEvent?.carteira_digital?.[0];
      const { limite, ...digitalWalletWithoutLimit } = digitalWallet || {};

      const isRecurringEvent = frequencyEvent === "RECORRENTE";
      const settingsData = {
        viewType: this.getCurrentEvent.dthr_pre_venda,
        emphasis: this.getCurrentEvent.destaque === 1,
        changeBearer: this.getCurrentEvent.troca_portador === 1,
        limitPerCustomer: (() => {
          try {
            return (
              JSON.parse(this.getCurrentEvent.limite_venda_cpf_por_tipo)
                ?.ingresso || 5
            );
          } catch (e) {
            return 5;
          }
        })(),
        url: this.getCurrentEvent.slug,
        accessPeriodStart: isRecurringEvent
          ? this.getCurrentEvent.hora_inicio_checkin
          : this.getCurrentEvent.dthr_inicio_checkin,
        accessPeriodEnd: isRecurringEvent
          ? this.getCurrentEvent.hora_termino_checkin
          : this.getCurrentEvent.dthr_termino_checkin,
        accessQuantity: this.getCurrentEvent.limite_uso,
        hasElevenAccess: this.getCurrentEvent.circus === 1,
        hasFacial: this.getCurrentEvent.is_facial === 1,
        showAgroupedEventsOnElevenTickets:
          this.getCurrentEvent.exibe_agrupamento,
        hasAgroupedEvents: this.getCurrentEvent.prod_agrupamento,
        agroupedEvents: this.getCurrentEvent.nidprod_agrupamento?.split(";"),
        balanceReleased: limite || 0,
        balanceSettings: digitalWalletWithoutLimit || 0,
        commissionWeb: this.getCurrentEvent.tipo_taxa_web || "COMISSAO",
        typeTaxWeb:
          this.getCurrentEvent.taxa_conveniencia_porcentagem_custom_web > 0 ||
          this.getCurrentEvent.comissao_porcentagem_custom_web > 0
            ? "percent"
            : "value",
        taxWeb:
          [
            this.getCurrentEvent.comissao_web,
            this.getCurrentEvent.taxa_conveniencia_web,
            this.getCurrentEvent.taxa_conveniencia_porcentagem_custom_web,
            this.getCurrentEvent.comissao_porcentagem_custom_web,
          ].find(value => value > 0) || 0,
        minimumTax: this.getCurrentEvent.taxa_minima,

        commissionPos: this.getCurrentEvent.tipo_taxa_pos || "CONVENIENCIA",
        typeTaxPos:
          this.getCurrentEvent.taxa_conveniencia_porcentagem_custom_pos > 0 ||
          this.getCurrentEvent.comissao_porcentagem_custom_pos > 0
            ? "percent"
            : "value",
        taxPos:
          [
            this.getCurrentEvent.comissao_pos,
            this.getCurrentEvent.taxa_conveniencia_pos,
            this.getCurrentEvent.taxa_conveniencia_porcentagem_custom_pos,
            this.getCurrentEvent.comissao_porcentagem_custom_pos,
          ].find(value => value > 0) || 0,
        hasProcessingTax: this.getCurrentEvent.taxa_processamento > 0,
        processingTax: this.getCurrentEvent.taxa_processamento,
        cancellationPeriod:
          this.getCurrentEvent.controla_cancelamento === 0
            ? "disabled"
            : this.getCurrentEvent.dias_canc_apos_compra === 7 &&
              this.getCurrentEvent.horas_canc_antes_evento === 48
            ? "default"
            : "custom",
        cancellationDays: this.getCurrentEvent.dias_canc_apos_compra,
        cancellationHours: this.getCurrentEvent.horas_canc_antes_evento,
        publication: this.getCurrentEvent.status,
        showSoldOutTickets:
          this.getCurrentEvent.exibir_ingressos_esgotados === 1,
        showVoucherCode: this.getCurrentEvent.exibir_midia,
      };
      this.setEventSettingsDataCached({ ...settingsData });
      this.setEventSettingsData({ ...settingsData });
    }
  },
  destroyed() {
    this.cleanAll();
  },
};
</script>

<style scoped></style>
